module.exports = __webpack_public_path__ + "static/img/fire.f58b44a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fire.gif
// module id = eyQq
// module chunks = 1